import { render, staticRenderFns } from "./RubricVersionStatusBadge.vue?vue&type=template&id=8a13306c&"
import script from "./RubricVersionStatusBadge.vue?vue&type=script&lang=ts&"
export * from "./RubricVersionStatusBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports